export const putImportPeriodsInitialState = {
	periods: null,
	error: null,
	errorShow: false,
	loading: false,
};
